/* Window globals for sitecore config */
declare global {
  /* eslint-disable */

  interface Base {
    npsSurveyUrl: string;
    pciPalUrl: string;
    pciPalTenantId: string;
    endpoints: {
      feefo: Endpoint;
      productReview: Endpoint;
    };
    velocityUrl?: string;
  }
  interface Config extends Base {
    baseUrl: string;
    msCommercialInsApi: string;
    digitalPaymentUrl: string;
    origin: string;
    sitecoreMediaApi: string;
    addressLookupApi: string;
    npsSurveyUrl: string;
    pciPalUrl: string;
    sitecoreConfigurationApi: string;
    addressApiUrl: string;
    apimSubscription: string;
    velocityUrl?: string;
    allowedOrigins: string[];
  }

  var _SME_: {
    ENV: TargetEnv;
    VERSION: string;
    BUILD: string;
    CONFIG: Config;
  };

  interface gaFunctions {
    getAll: Function;
  }

  interface Flex {
    microform: (arg: unknown, callback: (setupError: any, microformInstance: any) => void) => void;
  }

  interface Meta {
    appName: string;
    appPartner: string;
    appType: string;
    appEnv: string;
    appProduct: string;
    appRegion: string;
    dataPoints: object;
  }

  interface Window {
    dataLayer: Array<object>;
    ga: gaFunctions;
    FLEX: Flex;
  }

  namespace NodeJS {
    interface ProcessEnv extends NodeAppEnv {}
  }
}

interface NodeAppEnv {
  NODE_ENV?: 'development' | 'production';
  REACT_APP_SKIP_VALIDATE_STEP_ROUTE?: string;
  REACT_APP_USE_MOCK_API?: string;
}

export enum TargetEnv {
  local = 'local',
  dev = 'dev',
  sit = 'sit',
  sitbau = 'sit_bau',
  uat = 'uat',
  perf = 'perf',
  prod = 'prod',
}

export interface Endpoint {
  url: string;
  merchantIdentifier?: string;
  sharedKey?: string;
  badgeUrl?: string;
}

/*
 * If we are in production, we extract the env from the window global exported by
 * sitecore via their SPA Foot component to get context of which env we are in.
 * This allows us to deploy the same build to all environments, instead of deploying
 * a separate build per environment. (Build Once, Deploy Many approach)
 */
const targetEnv: TargetEnv =
  process.env.NODE_ENV === 'production' ? window._SME_.ENV : TargetEnv.local;

const buildInfo = {
  version: process.env.REACT_APP_VERSION ?? '',
  build: process.env.REACT_APP_BUILD ?? '',
};

window._SME_ = {
  ...window._SME_,
  VERSION: buildInfo.version,
  BUILD: buildInfo.build,
};

// Fallback values added for unit tests
const config: Config = {
  npsSurveyUrl: window._SME_.CONFIG?.npsSurveyUrl,
  pciPalUrl: window._SME_.CONFIG?.pciPalUrl,
  pciPalTenantId: window._SME_.CONFIG?.pciPalTenantId,
  endpoints: {
    feefo: {
      url: window._SME_.CONFIG?.endpoints.feefo.url,
      merchantIdentifier: window._SME_.CONFIG?.endpoints.feefo.merchantIdentifier,
      sharedKey: window._SME_.CONFIG?.endpoints.feefo.sharedKey,
      badgeUrl: window._SME_.CONFIG?.endpoints.feefo.badgeUrl,
    },
    productReview: {
      url: window._SME_.CONFIG?.endpoints.productReview.url,
    },
  },
  origin: window._SME_.CONFIG?.origin,
  baseUrl: window._SME_.CONFIG?.baseUrl,
  msCommercialInsApi:
    window._SME_.CONFIG?.msCommercialInsApi ||
    'https://sit.api-ext.qbe.com.au/x-digital-commercial-ins-qbe-anzo/api/v1',
  digitalPaymentUrl: window._SME_.CONFIG?.digitalPaymentUrl || 'http://localhost:4200',
  sitecoreMediaApi:
    window._SME_.CONFIG?.sitecoreMediaApi || 'https://qd-sit-spaapi-au.qbe.com/api/spa/v4/media',
  addressLookupApi:
    window._SME_.CONFIG?.addressLookupApi ||
    'https://sit.api-ext.qbe.com.au/x-digital-commercial-ins-qbe-anzo/api/v1',
  sitecoreConfigurationApi:
    window._SME_.CONFIG?.sitecoreConfigurationApi ||
    'https://qd-sit-spaapi-au.qbe.com/api/spa/v4/configuration',
  velocityUrl: window._SME_.CONFIG?.velocityUrl,
  allowedOrigins: window._SME_.CONFIG?.allowedOrigins,
  addressApiUrl: window._SME_.CONFIG?.addressApiUrl,
  apimSubscription: window._SME_.CONFIG?.apimSubscription,
};

/*
 * TODO - move this to .env file when app.config is refactored
 * Sitecore Item ID for
 * https://gp-sit-auth-au.qbe.com/sitecore/shell/Applications/Content%20Editor.aspx?sc_bw=1&ro=/sitecore/content/Australia/Settings/spa-settings/sme/sme---local
 */
const localSpaId = '{C3D2D40C-1DE3-49FC-9EBE-EDE1DB5BC5E3}';

/*
 * Fallback URL for when user exits the payment flow
 */
const EXIT_URL = 'https://www.qbe.com/au';

export { config, targetEnv, buildInfo, localSpaId, EXIT_URL };
